import {Product} from "../../Model/Catalog/Product";
import {EventEmitter, inject, Injectable} from "@angular/core";
import {NextPimField} from "../../Model/Catalog/NextPimField";
import {ExcelElement} from "../../Model/ui/ExcelElement";
import {TranslationService} from "../../Services/translation.service";

@Injectable()
export class NpInputControlContext {
    private translationService = inject(TranslationService);

    excelModel: ExcelElement[] | null = null;
    showDragHandle: boolean = false;
    model: Product = new Product();

    get productTranslation(): Product {
        return this.translationService.productTranslation;
    }

    showLinkButtons: boolean = false;
    selectedElements: string[] = [];
    dragFilter: string;
    isPrint: boolean = false;
    templateView = false;
    showHTMLSwitch = true;
    massDataChangeMode = false;

    valueChanged = new EventEmitter<any>();
    elementSelected = new EventEmitter<string>();
    elementDropped = new EventEmitter<any>();
    elementDelete = new EventEmitter<any>();
    pimFieldReordered = new EventEmitter<string>();
    pimFieldCleared = new EventEmitter<NextPimField>();
    pimFieldTemplateItemRemoved = new EventEmitter<{ field: NextPimField, templateItemTitle: string }>();
    translationUpdate = new EventEmitter<any>();
    selectedElementsChanged = new EventEmitter<boolean>();

    templateUpdated = new EventEmitter<any>();
    linkedFieldsChanged = new EventEmitter<void>();

    private popoverStates = new Map<string, PopoverState>();

    getPopoverState(key: string): PopoverState {
        let state = this.popoverStates.get(key);
        if (!state) {
            state = {visible: false, tabIndex: 0, tabDefaultApplied: false};
            this.popoverStates.set(key, state);
        }
        return state;
    }
}

export interface PopoverState {
    visible: boolean;
    tabIndex: number;
    tabDefaultApplied: boolean;
}